import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import WhatsAppWidget from './components/layout/WhatsAppWidget';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import PracticeAreas from './pages/PracticeAreas';
import Contact from './pages/Contact';
import FAQs from './pages/FAQs';
import FamilyLaw from './pages/FamilyLaw';
import CriminalLaw from './pages/CriminalLaw';
import CivilLaw from './pages/CivilLaw';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import AdminLogin from './pages/AdminLogin';
import AdminBlog from './pages/AdminBlog';
const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/practice-areas" element={<PracticeAreas />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faqs" element={<FAQs />} />
                <Route path="/services/family-law" element={<FamilyLaw />} />
                <Route path="/services/criminal-law" element={<CriminalLaw />} />
                <Route path="/services/civil-law" element={<CivilLaw />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/blog" element={<AdminBlog />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppWidget />
          </div>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;